import { withContent, Image } from '@bubbletea/core';
import { motion } from 'framer-motion';
import { FeaturesItem } from '../../../types/generatedContent';

import { WaveIcon } from '../../UI/Icons';
import { Container, Content, DescriptionContainer, ImageContainer, IconContainer } from './styles';
import Title from '../../UI/Title';

interface IKeyFeatureProps {
  feature: FeaturesItem;
  index?: number;
}

const KeyFeature = ({ feature, index = 0 }: IKeyFeatureProps) => {
  const { title, description, color, backImage, frontImage } = feature;
  return (
    <Container
      initial={{
        opacity: 0,
        y: 3,
      }}
      whileInView={{
        opacity: 1,
        y: 0,
      }}
      transition={{
        type: 'spring',
        delay: 0.2 + index * 0.1,
      }}
      viewport={{ once: true }}
      index={index}
    >
      <Content style={{ borderColor: color }}>
        <motion.div
          initial={{
            opacity: 0,
            x: -50,
          }}
          whileInView={{
            opacity: 1,
            x: 0,
          }}
          transition={{
            type: 'spring',
            delay: 0.2 + index * 0.1,
          }}
          viewport={{ once: true }}
        >
          <ImageContainer>
            <Image imageNames={[backImage as string]} classNames={['feature-back-image']} altText="" dynamic />
            <Image imageNames={[frontImage as string]} classNames={['feature-front-image']} altText="" dynamic />
          </ImageContainer>
        </motion.div>
        <IconContainer>
          <WaveIcon />
        </IconContainer>
        <Title as="h3" uppercase>
          {title}
        </Title>
        <DescriptionContainer dangerouslySetInnerHTML={{ __html: description as string }} />
      </Content>
    </Container>
  );
};

export default withContent(KeyFeature);
